import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useUpdateDestinationKioskDialogValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z
    .object({
      allowedKioskIds: z.array(z.number()),
      defaultHostId: z.number().nullable(),
      addHostStepEnabled: z.boolean(),
      hostObligatory: z.boolean(),
      hostConfirmationObligatory: z.boolean(),
      hostConfirmationInEmail: z.boolean(),
      deviceConfirmation: z.boolean(),
      kioskVisitHours: z.coerce
        .number({
          invalid_type_error: t('required'),
        })
        .min(
          1,
          t('minNumber', {
            number: 1,
          }),
        ),
    })
    .strict();
};
